
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.17,"time":10200.000000000002,"words":34}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "起因"
    }}>{`起因`}</h2>
    <p>{`之所以要搞这个小工具呢，主要就是markdown传图实在是不方便。现在有的相关产品，要么是不够精致，要么是太大而全，要么是Mac平台，总之就是没有我想要的那种。我的标准是什么呢？`}</p>
    <ul>
      <li parentName="ul">{`功能简单，只能传图`}</li>
      <li parentName="ul">{`不依赖于编辑器`}</li>
    </ul>
    <h2 {...{
      "id": "看东西"
    }}>{`看东西`}</h2>
    <p>{`凡是先bulabula的一堆再看东西的都是耍流氓。先来几张图，拿出来溜溜。或者直接去`}<a parentName="p" {...{
        "href": "https://github.com/mzvast/Picorz"
      }}>{`项目地址`}</a></p>
    <h3 {...{
      "id": "主界面"
    }}>{`主界面`}</h3>
    <p><img parentName="p" {...{
        "src": "http://mzvast.github.io/picorz-img/Picorz-clipboard-",
        "alt": null
      }}></img>{`
传图片主要有三种方式，橘黄色的三处均是与上传有关的：`}</p>
    <ul>
      <li parentName="ul">{`Drag&Drop区域：整个浅黄色区域都可以拖拽进去`}</li>
      <li parentName="ul">{`Paste按钮：将剪贴板的截图图片`}</li>
      <li parentName="ul">{`OpenFile按钮：直接打开文件选择器选择文件`}</li>
    </ul>
    <h3 {...{
      "id": "设置界面"
    }}>{`设置界面`}</h3>
    <p><img parentName="p" {...{
        "src": "http://mzvast.github.io/picorz-img/Picorz-pasteshot--2017-03-19T174551+0800",
        "alt": null
      }}></img>{`
使用之前，先要去Tools->Settings配置一下七牛的账户`}</p>
    <h2 {...{
      "id": "关于设计"
    }}>{`关于设计`}</h2>
    <p>{`这个Logo你懂的，无可奉告！`}</p>
    <p>{`这个软件名称么，大部分传图的工具都叫自己是xxxPic，然后我觉得好看的名字都被取完了。就表示跪了，Pic+Orz，这个就这么来了。`}</p>
    <p>{`这个配色么，源自于这个：09热情-原色•间色•复色-烂漫
`}<img parentName="p" {...{
        "src": "http://mzvast.github.io/picorz-img/Picorz-pasteshot--2017-03-19T192915+0800",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "关于程序"
    }}>{`关于程序`}</h2>
    <p>{`本软件是基于`}<a parentName="p" {...{
        "href": "https://electron.atom.io"
      }}>{`Electron`}</a>{`框架构建的。没有用任何前端JavaScript框架。应用的编译和打包成安装包是基于appveyor的，可以参见项目的appveyor.yml文件。`}</p>
    <p>{`友友可以去试用一下，有什么问题可以反馈到github上面，<3。`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "起因",
    level: 2,
    title: "起因",
    children: [
        
      ]
  },
{
    id: "看东西",
    level: 2,
    title: "看东西",
    children: [
        {
              id: "主界面",
              level: 3,
              title: "主界面",
              children: [
                      
                    ]
            },
      {
              id: "设置界面",
              level: 3,
              title: "设置界面",
              children: [
                      
                    ]
            }
      ]
  },
{
    id: "关于设计",
    level: 2,
    title: "关于设计",
    children: [
        
      ]
  },
{
    id: "关于程序",
    level: 2,
    title: "关于程序",
    children: [
        
      ]
  }
]

export const frontMatter = {}

